import { useMemo } from 'react'
import DashboardTablePagination from 'features/dashboard/table/DashboardTablePagination'
import SelectBox from 'components/form/SelectBox'
import ColumnSelect from 'features/dashboard/table/config/ColumnSelect'
import OnOffButtons from 'features/dashboard/operation/onOff/OnOffButtons'
import DeleteButton from 'features/dashboard/operation/delete/DeleteButton'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { useDispatch } from 'react-redux'
import { showAdGroupMaxBiddingAmountEdit } from 'features/dashboard/operation/adGroupMaxBiddingAmountEdit/adGroupMaxBiddingAmountEditSlice'
import { showAdGroupContentMatchingMaxBiddingAmountEdit } from 'features/dashboard/operation/adGroupContentMatchingMaxBiddingAmountEdit/adGroupContentMatchingMaxBiddingAmountEditSlice'
import { showAdGroupsWeightEdit } from 'features/dashboard/operation/adGroupWeightEdit/adGroupWeightEditSlice'
import { showAdGroupDailyBudgetEdit } from 'features/dashboard/operation/adGroupDailyBudgetEdit/adGroupDailyBudgetEditSlice'
import { showAdGroupDeviceEdit } from 'features/dashboard/operation/adGroupDeviceEdit/adGroupDeviceEditSlice'
import { showAdGroupPlacementEdit } from 'features/dashboard/operation/adGroupPlacementEdit/adGroupPlacementEditSlice'
import { showAdGroupDurationEdit } from 'features/dashboard/operation/adGroupDurationEdit/adGroupDurationEditSlice'
import { showAdGroupWeeklyScheduleEdit } from 'features/dashboard/operation/adGroupWeeklyScheduleEdit/adGroupWeeklyScheduleEditSlice'
import {
  KeywordExtensionTypes,
  showAdGroupKeywordExtensionEdit,
} from 'features/dashboard/operation/adGroupKeywordExtensionEdit/adGroupKeywordExtensionEditSlice'
import DownloadButton from 'features/dashboard/operation/download/DownloadButton'
import CreateAdGroupButton from 'features/dashboard/operation/createAdGroup/CreateAdGroupButton'
import AdGroupCopyButton from 'features/dashboard/operation/adGroupCopy/AdGroupCopyButton'
import { CampaignTypes } from '../../../Codes'

const AdGroupTableHeader = () => {
  const dispatch = useDispatch()
  const { selectedIds, content } = useDashboardTableSelector()
  const nonSelected = useMemo(() => selectedIds.length === 0, [selectedIds])
  const premiumLinkIds = useMemo(
    () =>
      content
        .filter(
          ({ id, adGroupType }) =>
            selectedIds.includes(id) &&
            adGroupType === CampaignTypes.PREMIUM_LINK
        )
        .map(({ id }) => id),
    [selectedIds, content]
  )
  const talkChannelIds = useMemo(
    () =>
      content
        .filter(
          ({ id, adGroupType }) =>
            selectedIds.includes(id) &&
            adGroupType === CampaignTypes.TALK_CHANNEL
        )
        .map(({ id }) => id),
    [selectedIds, content]
  )

  return (
    <div className="set_head">
      <div className="f_left">
        <div className="single_wrap">
          <CreateAdGroupButton />
        </div>
        <div className="single_wrap">
          <AdGroupCopyButton />
        </div>
        <div className="single_wrap">
          <OnOffButtons />
        </div>
        <div className="single_wrap">
          <SelectBox
            noBlurOnDefault
            className="opt_right"
            placeholder="선택한 광고그룹 수정"
            value
            disabled={nonSelected}>
            <SelectBox.Item
              tiaraAction="광고그룹탭_일예산_클릭"
              onClick={() => dispatch(showAdGroupDailyBudgetEdit(selectedIds))}>
              일예산
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_집행일자_클릭"
              onClick={() => dispatch(showAdGroupDurationEdit(selectedIds))}>
              집행일자
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_집행요일시간_클릭"
              onClick={() =>
                dispatch(showAdGroupWeeklyScheduleEdit(selectedIds))
              }>
              집행요일/시간
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_기본입찰가_클릭"
              disabled={premiumLinkIds.length === 0}
              onClick={() =>
                dispatch(showAdGroupMaxBiddingAmountEdit(premiumLinkIds))
              }>
              기본 입찰가
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_콘텐츠매체입찰가_클릭"
              disabled={premiumLinkIds.length === 0}
              onClick={() =>
                dispatch(
                  showAdGroupContentMatchingMaxBiddingAmountEdit(premiumLinkIds)
                )
              }>
              콘텐츠 매체 입찰가
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_입찰가중치_클릭"
              disabled={premiumLinkIds.length === 0}
              onClick={() => dispatch(showAdGroupsWeightEdit(premiumLinkIds))}>
              입찰가중치
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_매체유형_클릭"
              disabled={premiumLinkIds.length === 0}
              onClick={() =>
                dispatch(showAdGroupPlacementEdit(premiumLinkIds))
              }>
              매체유형
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_디바이스_클릭"
              disabled={premiumLinkIds.length === 0}
              onClick={() => dispatch(showAdGroupDeviceEdit(premiumLinkIds))}>
              디바이스
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_키워드확장_클릭"
              disabled={premiumLinkIds.length === 0}
              onClick={() =>
                dispatch(
                  showAdGroupKeywordExtensionEdit({
                    adGroupIds: premiumLinkIds,
                  })
                )
              }>
              키워드확장
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="광고그룹탭_분절_키워드_클릭"
              disabled={talkChannelIds.length === 0}
              onClick={() =>
                dispatch(
                  showAdGroupKeywordExtensionEdit({
                    adGroupIds: talkChannelIds,
                    type: KeywordExtensionTypes.segmentKeyword,
                  })
                )
              }>
              분절 키워드
            </SelectBox.Item>
          </SelectBox>
        </div>
        <div className="single_wrap">
          <DeleteButton />
        </div>
      </div>
      <div className="f_right">
        <div className="single_wrap">
          <DashboardTablePagination />
        </div>
        <div className="single_wrap">
          <ColumnSelect />
        </div>
        <div className="single_wrap">
          <DownloadButton />
        </div>
      </div>
    </div>
  )
}
export default AdGroupTableHeader
